import React, { useMemo } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// icons
import AndroidIcon from "@mui/icons-material/Android";
import WindowsIcon from "@mui/icons-material/Window";
import AppleIcon from "@mui/icons-material/Apple";
import IPhoneIcon from "@mui/icons-material/PhoneIphone";
import MacIcon from "@mui/icons-material/LaptopMac";
import TvIcon from "@mui/icons-material/Tv";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import RouterIcon from "@mui/icons-material/Router";

import { useNavigate, useParams } from "react-router-dom";

function NavTabs() {
  const navigate = useNavigate();
  const { platform } = useParams();

  const theme = useTheme();
  // Use theme breakpoints (no hardcoded widths)
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const deviceTabs = useMemo(
    () => [
      { platform: "ios", label: "iOS", icon: <IPhoneIcon fontSize="small" /> },
      { platform: "macos", label: "Mac", icon: <MacIcon fontSize="small" /> },
      { platform: "apple_tv", label: "Apple TV", icon: <AppleIcon fontSize="small" /> },
      { platform: "android", label: "Android", icon: <AndroidIcon fontSize="small" /> },
      { platform: "android_tv", label: "Android TV", icon: <TvIcon fontSize="small" /> },
      { platform: "windows", label: "Windows", icon: <WindowsIcon fontSize="small" /> },
      { platform: "linux", label: "Linux", icon: <DevicesOtherIcon fontSize="small" /> },
      { platform: "openwrt", label: "OpenWrt", icon: <RouterIcon fontSize="small" /> },
      { platform: "merlin", label: "Merlin", icon: <RouterIcon fontSize="small" /> },
      { platform: "thirdparty", label: "Third-party", icon: <DevicesOtherIcon fontSize="small" /> },
    ],
    []
  );

  const currentIndex = deviceTabs.findIndex((tab) => tab.platform === platform);
  const activeTab = currentIndex === -1 ? 0 : currentIndex;

  const handleTabChange = (event, newValue) => {
    const target = deviceTabs[newValue];
    if (target && target.platform) {
      navigate(`/client/${target.platform}/`);
    }
  };

  return (
    <Container>
      <Grid container item justifyContent="center" xs={12} mx="auto">
        <AppBar
          position="static"
          color="transparent"
          elevation={0}
          sx={{
            backgroundColor: "rgba(0,0,0,0.3)",
            borderRadius: "8px",
            mt: { xs: 2, md: 4 },
          }}
        >
          {isMobile ? (
            <FormControl
              fullWidth
              size="small"
              sx={{
                mt: 1,
                mb: 1,
                "& .MuiInputBase-root": {
                  backgroundColor: "rgba(255,255,255,0.9)",
                  color: "#111",
                  borderRadius: "999px",
                  paddingLeft: 2,
                  paddingRight: 2,
                },
                "& .MuiSelect-select": {
                  paddingY: 1,
                },
                "& .MuiSvgIcon-root": {
                  color: "#111",
                },
              }}
            >
              <Select
                value={deviceTabs[activeTab]?.platform || deviceTabs[0].platform}
                onChange={(event) => {
                  const value = event.target.value;
                  const index = deviceTabs.findIndex((tab) => tab.platform === value);
                  if (index !== -1) {
                    const target = deviceTabs[index];
                    navigate(`/client/${target.platform}/`);
                  }
                }}
                displayEmpty
              >
                {deviceTabs.map((tab) => (
                  <MenuItem key={tab.platform} value={tab.platform}>
                    {tab.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              textColor="inherit"
              indicatorColor="secondary"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              sx={{
                "& .MuiTabs-flexContainer": {
                  flexWrap: "nowrap",
                  justifyContent: "flex-start",
                },
                "& .MuiTabs-scrollButtons": {
                  display: "flex",
                  width: 40,
                  height: 32,
                  padding: 0,
                },
                "& .MuiTabs-scrollButtons .MuiSvgIcon-root": {
                  fontSize: "1.6rem",
                },
              }}
            >
              {deviceTabs.map((tab) => (
                <Tab
                  key={tab.platform}
                  icon={tab.icon}
                  iconPosition="start"
                  label={tab.label}
                  sx={{
                    color: "white",
                    fontSize: "0.75rem",
                    textAlign: "center",
                    minWidth: 80,
                    flex: "0 0 auto",
                    padding: { xs: "4px 8px", sm: "4px 12px" },
                  }}
                />
              ))}
            </Tabs>
          )}
        </AppBar>
      </Grid>
    </Container>
  );
}

export default NavTabs;
